import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Switch,
  Grid,
  Chip,
  IconButton,
  Divider,
} from "@mui/material";
import { X, Layout, RotateCcw } from "lucide-react";
import { WIDGET_REGISTRY } from "./widgetRegistry";

export const WidgetCatalogModal = ({
  open,
  onClose,
  layout,
  onToggleVisibility,
  onResetDefault,
}) => {
  const categories = ["Overview", "Attendees", "Operational", "Analytics"];

  const getWidgetConfig = (id) => layout.find((w) => w.id === id) || { hidden: false };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Layout size={22} color="#2563EB" />
          <Typography variant="h6" fontWeight="700" color="#1E293B">
            Manage Dashboard Widgets
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <X size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ py: 2 }}>
        {categories.map((cat) => {
          const categoryWidgets = Object.values(WIDGET_REGISTRY).filter((w) => w.category === cat);
          if (categoryWidgets.length === 0) return null;

          return (
            <Box key={cat} mb={3}>
              <Typography variant="subtitle2" fontWeight="700" color="#2563EB" sx={{ textTransform: "uppercase", letterSpacing: "0.05em", mb: 1.5 }}>
                {cat} Widgets
              </Typography>
              <Grid container spacing={2}>
                {categoryWidgets.map((w) => {
                  const cfg = getWidgetConfig(w.id);
                  const isVisible = !cfg.hidden;

                  return (
                    <Grid item xs={12} sm={6} key={w.id}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: "12px",
                          border: "1px solid #E7EAF0",
                          backgroundColor: isVisible ? "#FFFFFF" : "#F8FAFC",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ pr: 1 }}>
                          <Typography variant="subtitle2" fontWeight="700" color="#1E293B">
                            {w.title}
                          </Typography>
                          <Typography variant="caption" color="#64748B" sx={{ display: "block", mt: 0.25 }}>
                            {w.description}
                          </Typography>
                          <Chip
                            label={`${cfg.colSpan || w.defaultColSpan} Columns`}
                            size="small"
                            sx={{ mt: 1, fontSize: "0.7rem", height: 20, backgroundColor: "#EEF4FF", color: "#2563EB" }}
                          />
                        </Box>
                        <Switch
                          checked={isVisible}
                          onChange={() => onToggleVisibility(w.id)}
                          color="primary"
                        />
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          );
        })}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, justifyContent: "space-between" }}>
        <Button
          onClick={onResetDefault}
          startIcon={<RotateCcw size={16} />}
          color="error"
          sx={{ fontWeight: 600 }}
        >
          Reset to Default Layout
        </Button>

        <Button
          onClick={onClose}
          variant="contained"
          sx={{ backgroundColor: "#2563EB", fontWeight: 600, borderRadius: "8px", px: 3 }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
